<template>
  <div class="page-container" :style="{ display: noSteps ? 'block' : 'flex' }">

    <div class="page-container__steps" v-if="!noSteps">
      <slot name="before"></slot>
    </div>

    <div class="page-container__body" :style="{ 'backgroundColor': white ? '#fff' : '#f6f8f9', margin: noSteps ? '0' : ''}">
      <div class="page-container__body-content" id="scroll-session-block">
        <div class="page-container__header">
          <h1 class="page-container__title" v-if="title" :style="{ opacity: stickyStyle ? 0 : 1  }">{{ title }}
            <slot name="title"></slot>
          </h1>
          <h1 class="page-container__title_sticky" v-if="stickyStyle && title">{{ title }}
            <slot name="title"></slot>
          </h1>
          <div class="page-container__right">
            <slot name="controls"></slot>
          </div>
        </div>
        <div v-if="$slots.description" class="page-container__description">
          <slot name="description"></slot>
        </div>

        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import {mapActions, mapState} from "vuex";

export default {
  name: "PageContainer",
  props: {
    title: {
      type: String,
      required: false
    },
    noSteps: {
      type: Boolean,
    },
    white: {
      type: Boolean,
    }
  },
  computed: {
    ...mapState("visit", {
      visitStore: (state) => state.stage,
    }),

    visitStage() {
      if (!this.visitStore) return 0
      return this.visitStore || 0
    },
    stickyStyle() {
      return this.contentScroll >= 10 ? true : false
    }
  },
  data: () => ({
    contentScroll: 0,
    recommendation: null
  }),
  mounted() {
    document.querySelector('#scroll-session-block').onscroll = (() => {
      this.editScroll(document.querySelector('#scroll-session-block').scrollTop)
    })

  },
  methods: {
    ...mapActions({
      setRecommendation: "visit/SET_RECOMM"
    }),
    editScroll(t) {
      this.contentScroll = t

    },
    autoFocus() {
      Vue.nextTick(() => {
        this.$refs.recommendation.focus()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  min-height: 100%;

  &__header {
    position: relative;
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    margin: 20px 0 0 0;

    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 26px;

    color: #111;
    transition: all .2s ease;

    &_sticky {
      color: #000;

      position: fixed;
      top: 0;
      z-index: 2001;
    }
  }

  &__description {
    padding: 5px 0 25px 0;

    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #8E8E93;
  }

  &__steps {

    z-index: 2000;
    min-width: 300px;
    box-sizing: border-box;
    //border-right: 1px solid #d4dbe8;

    background: #fff;
    transition: all .3s ease;
    overflow: hidden;
    //box-shadow: 0 2px 4px rgba(55, 71, 79, 0.16), 0 4px 8px rgba(55, 71, 79, 0.08);

    height: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
  }

  @media only screen and (max-width: 1100px) {
    &__steps {
      min-width: 43px;
    }
  }

  &__body {
    //border-top: 1px solid #d4dbe8;

    background: #EFEFF4;
    height: calc(100vh - 60px);
    margin-left: 300px;
    width: -webkit-fill-available;
    margin-top: 60px;
    overflow-y: auto;

    @media only screen and (max-width: 1100px) {
     & {
       margin-left: 43px;
      }
    }

    &-before {
      width: 300px;
      box-sizing: border-box;
      background: rgb(244, 245, 247);
      border-right: 1px solid #d4dbe8;
      overflow: auto;
    }

    &-fix {
      position: fixed;
      top: 186px;
      transition: all 0.3s ease;

      &_fixed {
        position: fixed;
        top: 60px;
      }
    }

    .fixed-btn {
      padding: 20px 0;

      width: 300px;
      position: fixed;
      bottom: 0;
      text-align: center;
    }

    &-content {
      flex: 1;
      overflow-y: auto;
      padding: 20px 25px;

      @media only screen and (min-width: 1400px) {

        padding: 20px 110px;

      }

      //max-width: 1140px;
      //margin: 0 auto;
    }
  }
}


</style>

<style lang="scss">
.fixed-btn {
  &__recommendation {
    margin: 2px 0 5px 0;
  }
}
</style>
